module.exports = __webpack_public_path__ + "img/circle.ae618ad6.png";